'use strict';

(() => {

  function syncProductLabels(){

    document.querySelectorAll('[data-in-badge-product]').forEach(host=>{

      const output=host.querySelector('[data-in-badge-output]');

      const stored=host.querySelector('template[data-in-badge-fallback]');

      if(output&&stored)output.innerHTML=stored.innerHTML;

    });

    document.dispatchEvent(new CustomEvent('idolnest:labels:updated',{detail:{source:'product-tags-or-metafields'}}));

  }

  syncProductLabels();

  document.addEventListener('idolnest:cards:added',syncProductLabels);

  document.addEventListener('shopify:section:load',syncProductLabels);

  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(syncProductLabels));

})();

